import { Actions } from "vuex-smart-module";
import axios from "@/web_client/axios_config";

import UserAdminState from "./state";
import UserAdminMutations from "./mutations";
import UserAdminGetters from "./getters";
import Urls from "@/web_client/urls";
import { MutationTypes } from "../mutations-types";
import { IUpdateUser, IAssignToken, ICreateUser } from "./models";

const userAdminUrl = Urls.userUrls.admin;
const tokenListUrl = Urls.authUrls.tokenList;
const assignTokenUrl = Urls.authUrls.assignToken;

export default class UserAdminActions extends Actions<
  UserAdminState,
  UserAdminGetters,
  UserAdminMutations,
  UserAdminActions
> {
  loadUserList() {
    axios.get(userAdminUrl).then((resp) => {
      this.commit(MutationTypes.USER_LIST, resp.data);
    });
  }
  loadTokenList() {
    axios.get(tokenListUrl).then((resp) => {
      this.commit(MutationTypes.TOKEN_LIST, resp.data);
    });
  }
  //CRUD de Usuarios
  createUser(user: ICreateUser) {
    axios
      .post(userAdminUrl, user)
      .then(() => {
        this.dispatch("loadUserList");
      })
      .catch((err) => {
        console.error(err);
      });
  }
  patchUser(data: IUpdateUser) {
    axios
      .patch(userAdminUrl + `${data.id}/`, data)
      .then(() => {
        this.dispatch("loadUserList");
      })
      .catch((err) => {
        console.error(err);
      });
  }
  deleteUser(id: number) {
    axios
      .delete(userAdminUrl + `/${id}`)
      .then(() => {
        this.dispatch("loadUserList");
      })
      .catch((err) => {
        console.error(err);
      });
  }
  //Asignación de Tokens
  assignToken(tokenInfo: IAssignToken) {
    axios
      .post(assignTokenUrl, tokenInfo)
      .then(() => {
        this.dispatch("loadUserList");
        this.dispatch("loadTokenList");
      })
      .catch((err) => {
        console.error(err);
      });
  }
  //Borrar tokens
  deleteToken(userId: number) {
    axios
      .post(assignTokenUrl, { user: userId })
      .then(() => {
        this.dispatch("loadUserList");
        this.dispatch("loadTokenList");
      })
      .catch((err) => {
        console.error(err);
      });
  }
}
